module.exports = __webpack_public_path__ + "static/persona-2-30e18d73708f43277ec587130c82898e.png";